import { useState } from "react";
import { useLocation } from "react-router-dom";
import ActiveItemDetails from "components/active-item/ActiveItemDetails";
import ActiveItemProperties from "components/active-item/ActiveItemProperties";
import { createAPI } from "services/api/api";
import { useSoundPath } from "hooks/useSoundPath";

const SellPopupConfirm = ({ activeItem, closePopup, nextStep }) => {
  const api = createAPI();
  const [sellAmount, setSellAmount] = useState("");
  const { pathname } = useLocation();
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const playSound = useSoundPath();

  const setAmountHandler = (e) => {
    const { value } = e.target;

    const cleanedValue = value.replace(/[^0-9.,]/g, '');
    const decimalParts = cleanedValue.split(/[,\.]/);
    if (decimalParts.length > 2 || (decimalParts.length === 2 && decimalParts[1].length > 2)) {
      return;
    }

    setSellAmount(cleanedValue);
  };

  const isSubmitDisabled = () => Number(sellAmount) < 1 || isSubmitLoading === true;

  const getTypeOfItem = () => {
    const properties = activeItem.properties;

    const isPackType = properties.find(prop => prop.title === 'PackType');
    const isType = properties.find(prop => prop.title === 'Type');

    if (isPackType) {
      return isPackType.text + ' Pack';
    }

    if (isType) {
      return isType.text + ' Card';
    }
  };

  const submitHandle = () => {
    setIsSubmitLoading(true);
    playSound('main');
    const payload = { price: Number(sellAmount) };
    api
      .post(`/marketplace_listing/${activeItem.marketplace_id}/sell`, payload)
      .then(() => nextStep())
      .catch((error) => {
        console.log(error);
        nextStep("error");
      })
      .finally(() => setIsSubmitLoading(false));
  };

  return (
    <section className="sell-card" onClick={(e) => e.stopPropagation()}>
      <section className="sell-card__details">
        <ActiveItemDetails
          pathname={pathname}
          name={activeItem.name}
          img={activeItem.image}
          packType={activeItem.pack_type}
          tag={activeItem.tag}
          type={activeItem.type}
          properties={activeItem.properties}
        />
        <ActiveItemProperties properties={activeItem.properties} />
      </section>
      <section className="sell-card__info">
        <header className="sell-card__header">
          <h2 className="sell-card__title">Sell {getTypeOfItem()} </h2>
          <button className="sell-card__close" onClick={closePopup}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 4L4 12M4 4L12 12"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </button>
        </header>
        <form className="sell-card__info-form">
          <p className="sell-card__info-row">
            <label htmlFor="" className="sell-card__info-label">
              Enter a listing price.
            </label>
            <input
              type="number"
              className="sell-card__info-input"
              placeholder="$0"
              value={sellAmount}
              onInput={setAmountHandler}
              onBlur={() => sellAmount.trim() === '' && setSellAmount(0)}
            />
            <span className="sell-card__info-tip">USD</span>
          </p>
          <ul className="sell-card__info-price">
            <li className="sell-card__info-price-title">Price summary</li>
            <li className="sell-card__info-price-item">
              <span>Listing price</span>
              <span>${sellAmount}</span>
            </li>
            <li className="sell-card__info-price-item">
              <span>Marketplace Fee (5%)</span>
              <span>${(Number(sellAmount) * 0.05).toFixed(2)}</span>
            </li>
            <li className="sell-card__info-price-item">
              <span>Net amount to seller</span>
              <span>${(sellAmount - Number(sellAmount) * 0.05).toFixed(2)}</span>
            </li>
          </ul>
          <button
            className={`sell-card__info-form-submit ${isSubmitLoading ? 'loading' : ''}`}
            onClick={submitHandle}
            disabled={isSubmitDisabled()}
            type="button"
          >
            List for sale
          </button>
        </form>
      </section>
    </section>
  );
};

export default SellPopupConfirm;
